<div class="reportPageContainerOuter">
  <div class="fulfillmentLanding reportPageContainer">
    <div class="reportsPage prodAvailability">
      <h3>Release Items Audit</h3>
      <div class="form-sec">
        <div class="row margin-t20 margin-b10 margin-l0 margin-r0">
          <div class="col-sm-7 col-md-9 col-lg-10 smallPadRgt0 padding-l0">
            <div class="row search-box-outer">
              <div class="col-md-4 col-lg-3 padding-r0 borderRight padding-l0">

                <div class="category-dropdown material-select">
                  <ng-select [items]="searchTypeList"
                             name="ddlProductSearch"
                             [(ngModel)]="selectedValue"
                             (ngModelChange)="enableDisableSearch()"
                             [virtualScroll]="true"
                             [closeOnSelect]="true"
                             [selectOnTab]="true"
                             [clearable]="false"
                             bindValue="value"
                             labelForId="name"
                             [searchable]="false"
                             (change)="keepFilter(null, ' ')">
                  </ng-select>
                </div>
              </div>
              <div class="col-md-8 col-lg-9 padding-l0 padding-r0">
                <div class="material-select reports-search-filter">
                  <div #productSearch *ngIf="selectedValue === 'Product Name'">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');getReleaseItemsAuditLog();" [(ngModel)]="productFilters.Brand" (ngModelChange)="validateBrandSearch()"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-select #itemNo name="ddlItemNoSearch" *ngIf="selectedValue === 'Item Number'"
                             [items]="orderNoList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.ItemNo"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(itemNo,'ItemNo')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <div class="search-box-outer" *ngIf="selectedValue === 'Order Number'">
                    <div class="reports-search-filter">
                      <div class="search-box-outer margin-l10">
                        <div class="search-box wide100">
                          <span class="search-icon">
                            <i class="fas fa-search"></i>
                          </span>
                          <div class="select-container">
                            <input (keyup.enter)="keepFilter(null,'');" placeholder="Search..." type="text" [(ngModel)]="productFilters.OrderNo">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="search-box-outer" *ngIf="selectedValue === 'Change Quantity'">
                    <div class="reports-search-filter padding-l0">
                      <span class="compareDropdown">
                        <ng-select #select
                                   [items]="comparisonType"
                                   [(ngModel)]="filter.changeQtyAction"
                                   [virtualScroll]="true"
                                   class="custom-select-grower"
                                   [clearable]="false"
                                   [closeOnSelect]="true"
                                   bindLabel="value"
                                   bindValue="value"
                                   (change)="keepFilter();">
                        </ng-select>
                      </span>
                      <div class="search-box-outer chnageQuantityInput margin-l10">
                        <div class="search-box wide90">
                          <span class="search-icon">
                            <i class="fas fa-search"></i>
                          </span>
                          <div class="select-container">
                            <input (keyup.enter)="keepFilter(null,'');" placeholder="Search..." type="text" [(ngModel)]="productFilters.ChangeQty">
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-select #MarketingBrand name="ddlproductSearch" *ngIf="selectedValue === 'Marketing Brand'"
                             [items]="marketingMasterList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.MarketingBrandList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(MarketingBrand,'MarketingBrand')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                  <ng-select #SeedSize name="ddlproductSearch" *ngIf="selectedValue === 'Seed Size'"
                             [items]="seedsizeMasterList"
                             placeholder="Search..."
                             [multiple]="true"
                             [hideSelected]="true"
                             class="custom-select-grower"
                             [(ngModel)]="productFilters.SeedSizeList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(SeedSize,'SeedSize')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                  <ng-select #PackageSize name="ddlproductSearch" *ngIf="selectedValue === 'Package Size'"
                             [items]="packagesizeMasterList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.PackageSizeList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(PackageSize,'PackageSize')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                  <div #productSearch *ngIf="selectedValue === 'Technology'">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');getReleaseItemsAuditLog();" [(ngModel)]="productFilters.TechnologyList" (ngModelChange)="validateTechnologySearch()"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>
                  <ng-select #Treatment name="ddlproductSearch" *ngIf="selectedValue === 'Treatment'"
                             [items]="treatmentMasterList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.TreatmentList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(Treatment,'Treatment')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <ng-select #AccountNo *ngIf="selectedValue === 'Account' && isEvolveAccountRestriction == true"
                             [items]="ddlAccounts"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.AccountNo"
                             [virtualScroll]="true"
                             bindLabel="accountNameCityState"
                             bindValue="accountNumber"
                             [closeOnSelect]="true"
                             [searchFn]="accountSearchFn"
                             (change)="keepFilter(null, ' ')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row" *ngIf="item.accountNumber!=-1">
                          <div class="col-md-8">
                            <h4 class="name greenColor" [ngOptionHighlight]="search">
                              {{item.accountName}}
                            </h4>
                            <p class="address" [ngOptionHighlight]="search">
                              {{item.address1}},  {{item.city}}, {{item.state}} - {{item.zipCode}}
                            </p>
                            <p class="phoneNo" [ngOptionHighlight]="search">
                              {{item.primaryPhoneNumber}}
                            </p>
                            <p class="grower-nos">
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Account #: {{item.accountNumber}}
                              </span>
                            </p>
                          </div>
                        </div>
                        <div class="row" *ngIf="item.accountNumber==-1">
                          <div class="col-md-8">
                            <h4 class="name" [ngOptionHighlight]="search">
                              {{item.accountName}}
                            </h4>
                            <p class="grower-nos">
                              <span class="grower-gln" [ngOptionHighlight]="search">
                                Account #: {{item.accountNumber}}
                              </span>
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>
                  <div #productSearch *ngIf="selectedValue === 'Account No' && isEvolveAccountRestriction == false">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.TxtAccountNo"
                                 placeholder="Search..." type="text" pattern="^[0-9, ]+$" #accountCtrl>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div #productSearch *ngIf="selectedValue === 'Account Name' && isEvolveAccountRestriction == false ">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.AccountName"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedValue=='City'">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.City"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-select #ProductLine name="ddlproductSearch" *ngIf="selectedValue === 'Product Line'"
                             [items]="productLineMasterList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.ProductLineList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(ProductLine,'ProductLine')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <ng-select #BranchPlant name="ddlbranchPlantSearch" *ngIf="selectedValue === 'Branch Plant'"
                             [items]="branchPlantMasterList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.BranchPlantList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(BranchPlant,'BranchPlant')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <ng-select #RequestType name="ddlrequestTypeSearch" *ngIf="selectedValue === 'Request Type'"
                             [items]="requestTypeMasterList"
                             placeholder="Search..."
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.RequestTypeList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(RequestType,'RequestType')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <div *ngIf="selectedValue=='Release Number'">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.Releases"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <ng-select #Explanation name="ddlExplanationSearch" *ngIf="selectedValue === 'Explanation'"
                             [items]="explanationList"
                             placeholder="Search"
                             class="custom-select-grower"
                             [multiple]="true"
                             [hideSelected]="true"
                             [(ngModel)]="productFilters.ExplanationList"
                             [virtualScroll]="true"
                             bindLabel="value"
                             bindValue="value"
                             [closeOnSelect]="true"
                             [searchFn]="filterSearchFn"
                             (change)="keepFilter(Explanation,'Explanation')">
                    <ng-template ng-option-tmp let-item="item" let-index="index" let-search="searchTerm">
                      <div class="dropdown-template">
                        <div class="row">
                          <div class="col-md-8">
                            <p class="name">
                              {{item.value}}
                            </p>
                          </div>
                        </div>
                      </div>
                    </ng-template>
                    <ng-template ng-notfound-tmp let-searchTerm="searchTerm">
                      <div class="ng-option disabled">
                        No data found for "{{searchTerm}}"
                      </div>
                    </ng-template>
                  </ng-select>

                  <div *ngIf="selectedValue=='DOTTransaction ID'">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.DOTTransactionID"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedValue=='ERP Order Number'">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.ERPOrderNumber"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div *ngIf="selectedValue=='User ID'">
                    <div class="search-box-outer margin-l10">
                      <div class="search-box wide100">
                        <span class="search-icon">
                          <i class="fas fa-search"></i>
                        </span>
                        <div class="select-container">
                          <input (keyup.enter)="keepFilter(null, ' ');" [(ngModel)]="productFilters.UserID"
                                 placeholder="Search..." type="text">
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Duration'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="From" [matDatepickerFilter]="fromDateFilter"
                               readonly [(ngModel)]="productFilters.FromDate" (dateChange)="keepFilter(null, ' ');validateDateFilter('fromDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                  <div class="col-md-6 maturitySelect" *ngIf="selectedValue === 'Duration'">
                    <div class="text-center deliveryDatePicker">
                      <mat-form-field>
                        <input matInput [matDatepicker]="picker" (focus)="picker.open();" placeholder="To" [matDatepickerFilter]="toDateFilter"
                               readonly [(ngModel)]="productFilters.ToDate" (dateChange)="keepFilter(null, ' ');validateDateFilter('toDate', $event);">
                        <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                        <mat-datepicker #picker></mat-datepicker>
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-sm-5 col-md-3 col-lg-2 search-btn-outer text-center padding-l20 padding-r0">
            <div class="row">
              <div class="col-sm-6 padding-r15">
                <div class="search-btn">
                  <button mat-raised-button class="btns" (click)="keepFilter(null, ' ');getReleaseItemsAuditLog();" color="primary">Search</button>
                </div>
              </div>
              <div class="col-sm-6 padding-r15">
                <div class="search-btn">
                  <button mat-raised-button class="btns" color="primary" [disabled]="releaseItemsAuditDataSource?.data.length <= 0" (click)="export()">Export</button>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="row">
          <div class="col-md-10 padding-r0">
            <div class="chips-sec margin-b10">
              <div class="row selected-chip">
                <div class="col-sm-9 col-md-10 padding-l0">
                  <div>
                    <mat-chip-set>
                      <mat-chip selected *ngFor="let filterValue of filterValueList">
                        {{filterValue}}
                        <a href="Javascript:void(0);" (click)="clearFilter(filterValue)">
                          <i class="fas fa-times text-right"></i>
                        </a>
                      </mat-chip>
                    </mat-chip-set>
                  </div>
                </div>
                <div class="col-sm-3 col-md-2 text-right padding-r25" *ngIf="filterValueList.length > 0">
                  <a href="Javascript:void(0);" class="clearAll" (click)="clearAllFilter()">Clear All</a>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="fulfill-top-sec">
            <div class="row listing-action-items">
              <div class="col-xl-4 col-lg-4 col-md-4">
              </div>
              <div class="col-xl-8 col-lg-8 col-md-8 text-right">
                <mat-paginator #productPaginator [pageSize]="50" [pageSizeOptions]="[5, 10, 25, 50]"></mat-paginator>
              </div>
            </div>
          </div>
          <div class="tableContainer itemAuditTable">
            <table mat-table #productTable [dataSource]="releaseItemsAuditDataSource" matSort matSortDirection="desc" class="matTables productTable resultTable">

              <ng-container matColumnDef="itemDescription" sticky>
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="productNameBlock">Product </th>
                <td mat-cell *matCellDef="let element" class="order-info ">
                  <p>
                    {{element.brand}} - {{element.marketingBrandDescription}}
                  </p>
                  <p class="grower-name">
                    {{element.itemDescription}}
                  </p>
                </td>
              </ng-container>
              <ng-container matColumnDef="itemNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="ItemNo">Item Number</th>
                <td mat-cell *matCellDef="let element" class="text-center ">
                  <p>{{element.itemNumber}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="auditTime">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center auditTime"> Audit Time </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.auditTime | date:'MM-dd-yyyy h:mm:ss a'}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="releaseID">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center releaseNo"> Release Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.releaseID}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="accountName">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountName"> Account Name </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.accountName}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="accountNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountNumber"> Account Number </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.accountNumber}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="city">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center accountCity"> Account City </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.city}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="quantity">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="quantity text-center"> Quantity </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.quantity}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="changeQty">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center changeQty"> ChangeQty </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.changeQty}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="updatedBy">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center modifiedBy"> Modified By </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>
                    {{element.updatedBy}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="branch">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center branch"> Branch Plant</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.branch}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="requestType">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center requestType"> Request Type </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.requestType}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="explanation">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center treatmentDesc"> Explanation</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>
                    {{element.explanation}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="action">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center action"> Action </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p>{{element.action}}</p>
                </td>
              </ng-container>
              <ng-container matColumnDef="dotTransactionId">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center dotTranId"> DOTTransaction ID </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <p matTooltip="DO Transfer Transaction ID : {{element.dotTransactionId}}" [matTooltipPosition]="'above'">{{element.dotTransactionId}}</p>
                </td>
              </ng-container>

              <ng-container matColumnDef="erpOrderNumber">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center dotTranId"> ERP Order # </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span *ngIf="element.erpOrderNumber>0">{{element.erpOrderNumber}}</span>
                </td>
              </ng-container>

              <ng-container matColumnDef="seedSizeDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center seedSize"> Seed Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>
                    {{element.seedSizeDescription}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="packageSizeDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center packageSize"> Package Size </th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>
                    {{element.packageSizeDescription}}
                  </span>
                </td>
              </ng-container>
              <ng-container matColumnDef="treatmentDescription">
                <th mat-header-cell *matHeaderCellDef mat-sort-header class="text-center treatmentDesc"> Treatment</th>
                <td mat-cell *matCellDef="let element" class="text-center">
                  <span>
                    {{element.treatmentDescription}}
                  </span>
                </td>
              </ng-container>

              <tr mat-header-row *matHeaderRowDef="displayedColumns;sticky:true;"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
            </table>
            <div *ngIf="releaseItemsAuditDataSource == undefined || releaseItemsAuditDataSource?.data.length == 0" class="noDataMsg">
              <p>No Record Found.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
